import { ImageInputTheme } from './types';

export const defaultImageInputTheme: ImageInputTheme = {
  height: '100%',
  minHeight: '400px',
  maxWidth: '392px',
  maxImageHeight: '392px',
};
